var n = /* @__PURE__ */ ((L) => (L[L.FADE = 0] = "FADE", L[L.COLLAPSE = 1] = "COLLAPSE", L[L.GROW = 2] = "GROW", L[L.ZOOM = 3] = "ZOOM", L))(n || {}), t = /* @__PURE__ */ ((L) => (L[L.WAITING = 0] = "WAITING", L[L.NONE = 1] = "NONE", L[L.PROMPT_LOGIN = 2] = "PROMPT_LOGIN", L[L.BLOCK_SCREEN = 3] = "BLOCK_SCREEN", L))(t || {});
const o = "apeiron", r = 24, A = 300, O = 400, U = 200, F = 6e3;
export {
  n as ANIMATION_TYPE,
  o as DEFAULT_ALT,
  O as DEFAULT_ANIMATE_DURATION,
  U as DEFAULT_ANIMATE_SHORT_DURATION,
  r as DEFAULT_LIST_SIZE,
  F as DEFAULT_SNACKBAR_SHOW_DURATION,
  A as LOCAL_LIST_SIZE,
  t as RESTRICT_MODE
};
//# sourceMappingURL=layout.js.map
